import React from 'react'
import PropTypes from 'prop-types'

import SectionWithAssets from './SectionWithAssets'

export default function OtherPostsSection ({
  title,
  posts,
  baseSlug,
  cardComponent,
  tag,
  relatedNodesCurrentTags,
  postsCentered,
}) {
  let columns = 3
  if (posts.length === 4) {
    columns = 2
  }

  return (
    posts?.length > 0 && (
      <SectionWithAssets
        title={title}
        posts={posts.map((post) => ({ ...post, isRelatedArticle: true }))}
        cardComponent={cardComponent}
        columns={columns}
        baseSlug={baseSlug}
        tag={tag}
        relatedNodesCurrentTags={relatedNodesCurrentTags}
        postsCentered={postsCentered}
        pageAmount={posts.length < 3 ? posts.length : 3}
      />
    )
  )
}

OtherPostsSection.propTypes = {
  title: PropTypes.string.isRequired,
  posts: PropTypes.array.isRequired,
  baseSlug: PropTypes.string.isRequired,
  cardComponent: PropTypes.node.isRequired,
  tag: PropTypes.string.isRequired,
}
